export default "__VITE_ASSET__gg0DiKbX__"